import { render } from "./ActivityTabTitle.vue?vue&type=template&id=1bf5cea6&scoped=true"
import script from "./ActivityTabTitle.vue?vue&type=script&lang=js"
export * from "./ActivityTabTitle.vue?vue&type=script&lang=js"

import "./ActivityTabTitle.vue?vue&type=style&index=0&id=1bf5cea6&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf5cea6"]])

export default __exports__